import { Reveal } from "./Reveal";
import { STEPS } from "../lib/content";
import { ShieldCheck } from "lucide-react";

export const HowItWorks = ({ onBook }) => (
  <section id="how" data-testid="how-it-works" className="py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <p className="text-xs font-semibold tracking-[0.2em] text-brand uppercase mb-5">
              How it works
            </p>
            <h2 className="font-serif font-light text-4xl sm:text-5xl text-brand-ink leading-[1.02] tracking-tight">
              Four simple steps, one peaceful mind.
            </h2>
            <div className="mt-8 flex items-start gap-3 rounded-2xl bg-brand-sand p-5">
              <ShieldCheck className="text-brand shrink-0 mt-0.5" size={22} />
              <p className="text-sm text-brand-ink/75 leading-relaxed">
                No representative ever enters a home without the written consent
                of the family. Your permission comes first — always.
              </p>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-border border-y border-border">
            {STEPS.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.08}>
                <div
                  data-testid={`step-${s.n}`}
                  className="group flex gap-6 sm:gap-10 py-8 items-start hover:bg-brand-cream transition-colors px-2 -mx-2 rounded-xl"
                >
                  <span className="font-serif text-3xl sm:text-4xl text-brand/40 group-hover:text-brand transition-colors w-16 shrink-0">
                    {s.n}
                  </span>
                  <div>
                    <h3 className="font-serif text-2xl sm:text-3xl text-brand-ink mb-2">
                      {s.title}
                    </h3>
                    <p className="text-brand-ink/70 leading-relaxed max-w-xl">
                      {s.body}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
